/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LoginResponse,
  MagicLinkLogin,
  MagicLinkRequest,
} from '../models/index';
import {
    LoginResponseFromJSON,
    LoginResponseToJSON,
    MagicLinkLoginFromJSON,
    MagicLinkLoginToJSON,
    MagicLinkRequestFromJSON,
    MagicLinkRequestToJSON,
} from '../models/index';

export interface ApiAuthMagicLinkGenerateCreateRequest {
    magicLinkRequest: MagicLinkRequest;
}

export interface ApiAuthMagicLinkLoginCreateRequest {
    magicLinkLogin: MagicLinkLogin;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Generate magic link for login
     */
    async apiAuthMagicLinkGenerateCreateRaw(requestParameters: ApiAuthMagicLinkGenerateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MagicLinkRequest>> {
        if (requestParameters['magicLinkRequest'] == null) {
            throw new runtime.RequiredError(
                'magicLinkRequest',
                'Required parameter "magicLinkRequest" was null or undefined when calling apiAuthMagicLinkGenerateCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/auth/magic-link/generate/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MagicLinkRequestToJSON(requestParameters['magicLinkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MagicLinkRequestFromJSON(jsonValue));
    }

    /**
     * Generate magic link for login
     */
    async apiAuthMagicLinkGenerateCreate(requestParameters: ApiAuthMagicLinkGenerateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MagicLinkRequest> {
        const response = await this.apiAuthMagicLinkGenerateCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Authenticate a user using a previously generated magic link token. Returns JWT tokens upon successful authentication.
     * Register new user with email and password
     */
    async apiAuthMagicLinkLoginCreateRaw(requestParameters: ApiAuthMagicLinkLoginCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        if (requestParameters['magicLinkLogin'] == null) {
            throw new runtime.RequiredError(
                'magicLinkLogin',
                'Required parameter "magicLinkLogin" was null or undefined when calling apiAuthMagicLinkLoginCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/auth/magic-link/login/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MagicLinkLoginToJSON(requestParameters['magicLinkLogin']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Authenticate a user using a previously generated magic link token. Returns JWT tokens upon successful authentication.
     * Register new user with email and password
     */
    async apiAuthMagicLinkLoginCreate(requestParameters: ApiAuthMagicLinkLoginCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.apiAuthMagicLinkLoginCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
